import React from 'react';
import { Link } from "gatsby"
import {Dialog, DialogTitle, DialogContent, Button, Typography, IconButton, Divider} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import successImage from '../../images/success.png'


const PaymentSuccessDialog = ({open, handleClose}) => {
    return(
            <Dialog onClose={handleClose} open={open} >
                <DialogTitle className='text-center p-0' 
                    style={{minWidth:300, width: '30vw'}}>
                    <IconButton
                        className='float-left'
                        onClick={handleClose}
                    >
                        <CloseIcon fontSize='large'/>
                    </IconButton>
                    <Typography className='b-7 pt-3 mr-5'>
                        Thanks for purchasing Cloudpin Pro
                    </Typography>
                </DialogTitle>
                <Divider/>
                <DialogContent
                    className='text-center'
                >
                    <img src={successImage} className='mt-4' alt='Success'/>
                    <Typography style={{color:'grey'}}>YOU NOW HAVE ACCESS TO</Typography>
                    <Typography>Custom pin codes</Typography>
                    <Typography>Share to your location</Typography>
                    <Typography>Share files larger than 200MB</Typography>
                    <Typography> Password protected sharing</Typography>
                    <Button
                        onClick={handleClose}
                        variant='contained'
                        className='w-100 my-3'
                        style={{backgroundColor:'rgb(232, 87, 58)', color:'white'}}
                    >
                        OK
                    </Button>
                </DialogContent>
            </Dialog>
    )
};

export default PaymentSuccessDialog;
